import { useEffect, useState } from 'react'
import { AsideActionWrapper } from '~/components/Layout/AsideActionWrapper/AsideActionWrapper'
import { ActionsButtonList } from '~/domains/actions/components/ActionsButtonList/ActionsButtonList'
import type { AsideActionPosition } from '~/types/global'
import {
  applicantModalAsideActions,
  applicantModalAsideActionsTitle
} from './ApplicantModalActions.css'

export const ApplicantModalActions = ({
  applicantId,
  contextOrder,
  hasEmail = true
}: {
  applicantId: number
  contextOrder?: {
    id: number
    willChangeStatus: boolean
  }
  hasEmail?: boolean
}) => {
  const [currentAction, setCurrentAction] = useState<string | null>(null)
  const [currentHoverAction, setCurrentHoverAction] = useState<string | null>(
    null
  )
  const [availablePositions, setAvailablePositions] = useState<
    AsideActionPosition[]
  >(['modal'])

  useEffect(() => {
    const handleResize = () => {
      setAvailablePositions(
        window.innerWidth > 1600 ? ['bottom', 'modal'] : ['bottom']
      )
    }
    window.addEventListener('resize', handleResize)
    handleResize()
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <div className={applicantModalAsideActions}>
      <div className={applicantModalAsideActionsTitle}>
        {currentHoverAction ?? currentAction ?? 'Actions rapides'}
      </div>
      <ActionsButtonList
        target={{ type: 'applicant', ids: [applicantId] }}
        contextOrder={contextOrder}
        onActionHover={setCurrentHoverAction}
        onCurrentActionChange={setCurrentAction}
        availablePositions={availablePositions}
        defaultPosition="bottom"
        hasEmail={hasEmail}
        showTaskOnboarding
      />
      <AsideActionWrapper position="bottom" />
    </div>
  )
}
